export default __webpack_public_path__ + "static/media/influencerImage.938e521f.png";